import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import 'shepherd.js/dist/css/shepherd.css';

// Suppress debug logs in production to prevent PII leakage in browser console
if (import.meta.env.PROD) {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  // console.error and console.warn are intentionally kept for runtime error visibility
}

createRoot(document.getElementById('root')!).render(
  <App />
);
